<label
	class="cursor-pointer block mb-1 text-sm font-medium text-gray-900 dark:text-white"
	[htmlFor]="key"
	>{{ title }}
	<span
		*ngIf="formGroup.get(key) | controlRequired"
		[ngClass]="{ 'text-warn-600': formGroup.get(key)!.invalid }"
		>*</span
	>
</label>
<div class="">
	<ng-container [formGroup]="formGroup" *ngIf="!scope.loading(); else loading">
		<div>
			<ng-select
				class="bg-gray-50 block text-md"
				#select
				notFoundText="Não encontrado"
				appendTo="body"
				[items]="scope.data"
				[formControlName]="key"
				bindLabel="name"
				[compareWith]="compareFn"
				[virtualScroll]="true"
				(keyup.esc)="$event.preventDefault()"
				placeholder="Selecione">
				<ng-template ng-label-tmp let-item="item" let-clear="clear">
					<div class="ng-value" [title]="item.name">
						<span
							*ngIf="this.scope.userCanEdit"
							class="btnEdit mr-1"
							(mousedown)="$event.stopPropagation()"
							(click)="edit($event, item, select)"
							><em class="fa fa-pencil left-0"></em>
						</span>
						<span class="ng-value-label">{{ item.name | findLanguageFromKey }}</span>
					</div>
				</ng-template>
				<ng-template ng-footer-tmp *ngIf="this.scope.userCanNew">
					<p class="create-new" (click)="createNew(select)">Criar</p>
				</ng-template>
			</ng-select>
			<div *ngIf="formGroup.get(key)?.dirty || formGroup.get(key)?.touched">
				<div
					class="transition-all duration-400 origin-top"
					[ngClass]="{
						'scale-y-100': formGroup.get(key)!.invalid,
						'scale-y-0': !formGroup.get(key)!.invalid
					}">
					<small class="flex flex-col text-warn-600" *ngIf="formGroup.get(key)?.errors?.required">
						É obrigatório
					</small>
				</div>
			</div>
		</div>
	</ng-container>
	<ng-template #loading>
		<div>
			<span class="p-input-icon-right">
				<i class="pi pi-spin pi-spinner"></i>
				<input [name]="key" [id]="key" pInputText disabled />
			</span>
		</div>
	</ng-template>
</div>
